module.exports = __webpack_public_path__ + "images/928478b2fb89751ad9fd78209e999b20-logo_virtual.png";